<app-page class="small">
  <ng-template #head>
    <ng-container [ngTemplateOutlet]="expo_template"></ng-container>
  </ng-template>
</app-page>

<app-page class="medium">
  <ng-template #head>
    <ng-container [ngTemplateOutlet]="expo_template"></ng-container>
  </ng-template>
  <ng-template #col1>
  </ng-template>
  <ng-template #col2>
  </ng-template>
</app-page>

<app-page class="large">
  <ng-template #head>
    <ng-container [ngTemplateOutlet]="expo_template"></ng-container>
    </ng-template>
  <ng-template #col1>
  </ng-template>
  <ng-template #col2>
  </ng-template>
  <ng-template #col3>
  </ng-template>
</app-page>

<ng-template #expo_template>
  <app-card [content]="exposition"></app-card>
</ng-template>

<!-- <ng-template #text_template>
  <app-card [content]="information"></app-card>
</ng-template> -->


